import * as _4 from 'lodash4';
import { INVALID_ID } from '../constants/ap_id_constants';

export interface IAPGenericCourse {
  id: number;
  title: string;
  credits: number;
  rank: number;
  has_coreq: boolean;
  has_prereq: boolean;
  nk: string;
}
export interface IAPGenericProgramSlot {
  id: number;
  title: string;
  course_group_id: number;
  slot_desc: string;
  slot_type: string;
  instructions: string | null;
  courses: IAPGenericCourse[];
}

export interface IAPPlannedCourse extends IAPGenericCourse {
  course_id: number;
  slot_id: number;
  status: string;
  slot_courses: IAPGenericCourse[];
}

export interface IAPPlannedCourseGroup extends IAPGenericProgramSlot {
  slot_id: number;
}

export interface IPlannedTerm {
  id: number;
  name: string;
  cat_yr: number;
  nk: string;
  rank: number;
  status: string | null;
  display_status: string | null;
  credits_range: string;
  recommended_credits: number | null;
  is_completed: boolean;
  credits: number;
  term_id: number;
  plannedcourse_set: IAPPlannedCourse[];
  plannedcoursegroup_set: IAPPlannedCourseGroup[];
}
export class APMmDataHelper {
  constructGenericSlots(programSlots: IAPGenericProgramSlot[]) {
    return _4.map(programSlots, (slot: IAPGenericProgramSlot) => {
      const {
        id,
        slot_type: slotType,
        slot_desc: slotDesc,
        course_group_id: courseGroupId,
        instructions,
        title
      } = slot;
      const courses = this._addSlotIdToCourses(slot.courses, slot.id);
      return {
        id,
        title,
        slotType,
        slotDesc,
        courseGroupId,
        instructions,
        courses
      };
    });
  }
  private _addSlotIdToCourses(courses: IAPGenericCourse[], slotId: number) {
    return _4.map(courses, (course: IAPGenericCourse) => ({ ...course, slotId }));
  }

  private _plannedCourseSlotCourses(plannedCourse: IAPPlannedCourse) {
    let slotCourses: IAPGenericCourse[] = [];
    const slotId = plannedCourse.slot_id || INVALID_ID;
    const _slotCourses: IAPGenericCourse[] = _4.get(plannedCourse, 'slot_courses', []);
    if (_slotCourses.length > 1) {
      slotCourses = _4.map(_slotCourses, (slotCourse: IAPGenericCourse) => {
        return { ...slotCourse, slotId };
      });
    }
    return slotCourses;
  }

  constructStudentTermsData(plannedTerms: IPlannedTerm[]) {
    return _4.map(plannedTerms, (term: IPlannedTerm) => {
      const {
        id,
        credits,
        cat_yr: catYear,
        name,
        rank = 1,
        term_id: termId,
        nk,
        plannedcourse_set,
        plannedcoursegroup_set
      } = term;

      const plannedCourses = _4.map(plannedcourse_set, (plannedCourse: IAPPlannedCourse) => ({
        ...plannedCourse,
        type: 'COURSE',
        nk: plannedCourse['course_nk'] || plannedCourse.nk,
        slotId: plannedCourse.slot_id,
        status: _4.toUpper(plannedCourse.status || ''),
        slot_courses: this._plannedCourseSlotCourses(plannedCourse)
      }));
      const status = _4.toUpper(term.status || 'PLANNED');
      const displayStatus = `Term Status: ${term.display_status || 'Term Planned'}`;
      const creditsRange = _4.get(term, 'credits_range', '');
      const recommendedCredits = term.recommended_credits;
      const showCreditsWarning = _4.get(term, 'show_credits_warning', false);
      const isCompleted = _4.get(term, 'is_completed', false);
      const plannedCourseGroups = _4.map(plannedcoursegroup_set, (plannedCourseGroup: IAPPlannedCourseGroup) => ({
        ...plannedCourseGroup,
        status: 'PLANNED',
        slotDesc: plannedCourseGroup.slot_desc,
        courseGroupId: plannedCourseGroup.course_group_id,
        courses: this._addSlotIdToCourses(plannedCourseGroup.courses, plannedCourseGroup.slot_id),
        type: 'GROUP'
      }));
      return {
        id,
        name,
        rank,
        credits,
        nk,
        status,
        displayStatus,
        creditsRange,
        recommendedCredits,
        showCreditsWarning,
        isCompleted,
        termId,
        catYear,
        plannedCourses,
        plannedCourseGroups
      };
    });
  }
}

angular.module('capability-ng-academic-planner').service('ngAPMmDataHelper', APMmDataHelper);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/helpers/ap_multi_plan_helper.ts